/**
 * SS METHOD — Isolated Knowledge Base
 * 
 * STRICT RULE: This data is completely separate from general numerology.
 * No mixing with numerologyDescriptions.js or any other data source.
 * 
 * Structure:
 *   SS_CORE_BASE[number] → { base_meaning, keys, shadows, mature }
 *   Future: SS_CATEGORIES[category][eventType][number] → specific interpretation
 */

export const SS_CORE_BASE = {
  1: {
    base_meaning: `Skaičius 1 kalba apie žmogaus valią, savarankiškumą ir vidinį impulsą pradėti kažką iš savo sprendimo. Tai energija, kuri nenori laukti leidimo, pritarimo ar tinkamo momento — ji nori veikti, rinktis kryptį ir pačiai kurti judėjimą.

1 dažnai pasirodo ten, kur žmogui reikia atsistoti ant savo kojų, prisiimti atsakomybę už save ir nustoti remtis vien kitais. Tai lyderystės, iniciatyvos ir asmeninės jėgos skaičius.
Ši energija moko pasitikėti savimi, išdrįsti būti pirmam, priimti sprendimus ir eiti savo keliu net tada, kai aplink nėra palaikymo.

Tačiau šešėlinėje pusėje 1 gali tapti užsispyrimu, ego kova, noru viską kontroliuoti arba įrodinėti savo vertę per jėgą. Tada žmogus ne kuria kryptį, o kovoja su pasauliu.
Brandi 1 energija reiškia ramų vidinį autoritetą: kai žmogui nebereikia šaukti, kad būtų stiprus. Jis tiesiog žino, kas jis yra, ir juda pirmyn.`,
    keys: [
      'pradžia',
      'sprendimas',
      'savarankiškumas',
      'iniciatyva',
      'kryptis',
      'lyderystė',
      'asmeninė atsakomybė',
      'drąsa būti savimi',
    ],
  },

  2: {
    base_meaning: `Skaičius 2 kalba apie ryšį, jautrumą ir gebėjimą jausti ne tik save, bet ir kitus žmones. Tai energija, kuri ieško balanso, bendradarbiavimo ir harmonijos. Ji retai veržiasi pirmyn jėga — dažniau juda per švelnumą, intuiciją ir gebėjimą suprasti situaciją giliau.

2 dažnai pasirodo ten, kur žmogui svarbu kurti santykį, mokytis kantrybės ir suprasti, kad ne viską gyvenime galima pasiekti spaudimu. Tai partnerystės, diplomatijos ir emocinio intelekto skaičius.

Ši energija moko klausytis, išgirsti tarp eilučių, pastebėti niuansus ir veikti ne vien protu, bet ir širdimi. Ji padeda kurti tiltus tarp žmonių, sutaikyti konfliktus ir atrasti kelią ten, kur grubumas tik viską sugadintų.

Tačiau šešėlinėje pusėje 2 gali tapti perdėtu prisitaikymu, baime konfliktuoti, priklausomybe nuo kitų nuomonės arba nuolatiniu savęs aukojimu dėl ramybės. Tada žmogus pameta save bandydamas išlaikyti visus aplink patenkintus.

Brandi 2 energija reiškia vidinę ramybę ir emocinę stiprybę: kai žmogus geba būti švelnus, bet neprarasti savo ribų. Jis moka bendradarbiauti, tačiau nepamiršta ir savęs.`,
    keys: [
      'ryšys',
      'partnerystė',
      'jautrumas',
      'harmonija',
      'intuicija',
      'bendradarbiavimas',
      'kantrybė',
      'emocinė pusiausvyra',
    ],
  },

  3: {
    base_meaning: `Skaičius 3 kalba apie saviraišką, kūrybą ir gyvą gyvenimo energiją. Tai skaičius, kuris nori judėti, kalbėti, dalintis mintimis ir būti matomas. Jis neša lengvumą, įkvėpimą ir norą kurti kažką, kas džiugina ne tik patį žmogų, bet ir aplinkinius.
3 dažnai pasirodo ten, kur žmogui svarbu atrasti savo balsą, išdrįsti parodyti talentus ir nustoti slėpti tai, kas gyva jo viduje. Tai komunikacijos, charizmos ir kūrybinio potencialo skaičius.

Ši energija moko džiaugtis procesu, nebijoti kalbėti apie save, skleisti idėjas ir į gyvenimą įnešti daugiau spalvų. Ji padeda lengviau užmegzti kontaktus, įkvėpti kitus ir matyti galimybes ten, kur kiti mato rutiną.

Tačiau šešėlinėje pusėje 3 gali tapti paviršutiniškumu, blaškymusi, dėmesio troškimu arba įpročiu viską pradėti, bet mažai ką užbaigti. Tada žmogus daug kalba, bet mažai įgyvendina, ieško įspūdžio vietoje tikros vertės.

Brandi 3 energija reiškia kūrybinę brandą ir nuoširdžią saviraišką: kai žmogus nebando patikti visiems, o drąsiai rodo tai, kas autentiška. Jo žodžiai ir darbai tampa įkvepiantys, nes kyla iš tikro vidaus.`,
    keys: [
      'saviraiška',
      'kūryba',
      'bendravimas',
      'charizma',
      'įkvėpimas',
      'džiaugsmas',
      'talentas',
      'matomumas',
    ],
  },

  4: {
    base_meaning: `Skaičius 4 kalba apie stabilumą, tvarką ir gebėjimą kurti tvirtą pagrindą ateičiai. Tai energija, kuri vertina realius veiksmus, nuoseklumą ir atsakomybę. Ji retai ieško greitų rezultatų — dažniau renkasi kelią, kuriame viskas statoma žingsnis po žingsnio.

4 dažnai pasirodo ten, kur žmogui svarbu sustiprinti savo gyvenimo pamatus, išmokti disciplinos ir suprasti, kad ilgalaikė vertė gimsta per kantrybę. Tai darbo, struktūros ir patikimumo skaičius.

Ši energija moko laikytis žodžio, planuoti, užbaigti pradėtus darbus ir kurti tai, kas gali tarnauti ilgai. Ji padeda susitvarkyti chaosą, įvesti aiškumą ir paversti idėjas konkrečiu rezultatu.

Tačiau šešėlinėje pusėje 4 gali tapti sustingimu, perdėtu kontroliavimu, baime keistis arba gyvenimu vien pareigose. Tada žmogus gali tapti griežtas sau ir kitiems, prarasti lankstumą bei džiaugsmą.

Brandi 4 energija reiškia ramų vidinį tvirtumą ir patikimumą: kai žmogus geba kurti struktūrą, bet lieka gyvas ir atviras pokyčiams. Jo jėga slypi ne triukšme, o stabilume.`,
    keys: [
      'stabilumas',
      'tvarka',
      'disciplina',
      'atsakomybė',
      'pagrindas',
      'darbas',
      'patikimumas',
      'nuoseklumas',
    ],
  },

  5: {
    base_meaning: `Skaičius 5 kalba apie laisvę, judėjimą ir gyvenimo pokyčius. Tai energija, kuri nenori sustingti vienoje vietoje ir nuolat ieško naujų patirčių, platesnių galimybių bei gyvesnio ritmo. Ji mėgsta įvairovę, spontaniškumą ir jausmą, kad gyvenimas teka, o ne stovi vietoje.

5 dažnai pasirodo ten, kur žmogui svarbu išsilaisvinti iš ribojimų, plėsti savo pasaulį ir drįsti rinktis kitaip nei buvo įprasta. Tai permainų, nuotykių ir asmeninės laisvės skaičius.

Ši energija moko prisitaikyti prie naujų aplinkybių, greitai reaguoti, mokytis per patirtį ir nebijoti keisti krypties, kai sena jau nebeauga. Ji padeda atrasti drąsą išeiti iš rutinos, sutikti naujus žmones ir pamatyti daugiau gyvenimo spalvų.

Tačiau šešėlinėje pusėje 5 gali tapti chaosu, nepastovumu, impulsyviais sprendimais arba nuolatiniu bėgimu nuo atsakomybės. Tada žmogus siekia laisvės, bet pats susikuria nestabilumą ir vidinį išsibarstymą.

Brandi 5 energija reiškia sąmoningą laisvę ir gyvą lankstumą: kai žmogus juda pirmyn ne todėl, kad bėga, o todėl, kad auga. Jis moka keistis neprarasdamas savęs.`,
    keys: [
      'laisvė',
      'pokyčiai',
      'judėjimas',
      'įvairovė',
      'prisitaikymas',
      'drąsa',
      'patirtis',
      'plėtra',
    ],
  },

  6: {
    base_meaning: `Skaičius 6 kalba apie meilę, atsakomybę ir gebėjimą kurti saugumą sau bei kitiems. Tai energija, kuri natūraliai rūpinasi, saugo ir siekia harmonijos aplinkoje. Ji vertina artumą, namų jausmą, grožį ir santykius, kuriuose yra pagarba bei šiluma.

6 dažnai pasirodo ten, kur žmogui svarbu išmokti brandžios meilės, prisiimti atsakomybę už tai, ką kuria, ir suprasti tikrąją rūpesčio vertę. Tai šeimos, globos ir širdies brandos skaičius.

Ši energija moko mylėti ne vien žodžiais, bet veiksmais: palaikyti, padėti, būti patikimu ir kurti aplink save daugiau ramybės. Ji padeda stiprinti ryšius, rūpintis namais, artimaisiais ir tuo, kas žmogui iš tikrųjų brangu.

Tačiau šešėlinėje pusėje 6 gali tapti perdėta našta, nuolatiniu gelbėtojo vaidmeniu, kontrole per rūpestį arba savęs pamiršimu dėl kitų. Tada žmogus duoda tiek daug, kad pats lieka tuščias ir nepastebėtas.

Brandi 6 energija reiškia subalansuotą meilę ir išmintingą atsakomybę: kai žmogus rūpinasi kitais, bet nepamiršta ir savęs. Jo šiluma gydo, o jo buvimas kuria saugumą.`,
    keys: [
      'meilė',
      'atsakomybė',
      'šeima',
      'rūpestis',
      'harmonija',
      'saugumas',
      'globa',
      'širdies branda',
    ],
  },

  7: {
    base_meaning: `Skaičius 7 kalba apie gylį, išmintį ir vidinį tiesos ieškojimą. Tai energija, kuri nesitenkina paviršiumi ir nori suprasti, kas slypi giliau už matomų dalykų. Ji traukia į apmąstymą, savęs pažinimą ir gyvenimo prasmės paieškas.

7 dažnai pasirodo ten, kur žmogui svarbu sustoti, atsitraukti nuo triukšmo ir išgirsti savo tikrą vidinį balsą. Tai analizės, intuicijos ir dvasinės brandos skaičius.

Ši energija moko stebėti, mąstyti, nepasitenkinti greitais atsakymais ir augti per suvokimą. Ji padeda gilintis į žinias, tyrinėti save, matyti ženklus bei ryšius, kurių kiti nepastebi.

Tačiau šešėlinėje pusėje 7 gali tapti užsidarymu, šaltumu, perdėtu nepasitikėjimu arba nuolatiniu abejojimu viskuo. Tada žmogus atsitraukia ne dėl išminties, o dėl baimės būti sužeistas ar nesuprastas.

Brandi 7 energija reiškia ramų vidinį aiškumą ir gilų pasitikėjimą savimi: kai žmogui nebereikia triukšmo, kad žinotų tiesą. Jo stiprybė slypi gebėjime matyti esmę.`,
    keys: [
      'gylis',
      'išmintis',
      'intuicija',
      'analizė',
      'tiesa',
      'savęs pažinimas',
      'prasmė',
      'vidinis aiškumas',
    ],
  },

  8: {
    base_meaning: `Skaičius 8 kalba apie galią, rezultatą ir gebėjimą valdyti materialų pasaulį. Tai energija, kuri siekia augimo, stiprios pozicijos ir apčiuopiamos sėkmės. Ji vertina efektyvumą, atsakomybę bei gebėjimą paversti idėjas realiais pasiekimais.

8 dažnai pasirodo ten, kur žmogui svarbu išmokti naudotis savo jėga brandžiai, priimti didesnę atsakomybę ir kurti vertę ne tik sau, bet ir platesniam ratui. Tai lyderystės, finansinės brandos ir įtakos skaičius.

Ši energija moko strateginio mąstymo, disciplinos, ilgalaikio planavimo ir drąsos priimti svarbius sprendimus. Ji padeda auginti verslą, stiprinti statusą, valdyti išteklius ir siekti didesnių tikslų.

Tačiau šešėlinėje pusėje 8 gali tapti godumu, perdėtu kontroliavimu, šaltu ambicingumu arba savivertės matavimu vien pinigais ir statusu. Tada žmogus laimi išoriškai, bet praranda vidinę pusiausvyrą.

Brandi 8 energija reiškia sąžiningą galią ir išmintingą atsakomybę: kai žmogus geba kurti sėkmę negriaudamas savęs ar kitų. Jo stiprybė slypi ne spaudime, o tvirtame valdyme.`,
    keys: [
      'galia',
      'sėkmė',
      'rezultatas',
      'atsakomybė',
      'finansai',
      'lyderystė',
      'strategija',
      'įtaka',
    ],
  },

  9: {
    base_meaning: `Skaičius 9 kalba apie brandą, užbaigimą ir platesnį gyvenimo supratimą. Tai energija, kuri kviečia pakilti virš smulkių kovų ir pamatyti didesnį paveikslą. Ji siejama su išmintimi, atjauta, vidine jėga ir gebėjimu paleisti tai, kas jau atliko savo vaidmenį.

9 dažnai pasirodo ten, kur žmogui svarbu uždaryti senus ciklus, išsigryninti vertybes ir pereiti į brandesnį gyvenimo etapą. Tai tarnystės, humanizmo ir sielos augimo skaičius.

Ši energija moko atleisti, paleisti prisirišimus, padėti kitiems neprarandant savęs ir gyventi ne vien dėl siaurų asmeninių tikslų. Ji padeda suprasti gyvenimo pamokas, matyti ryšius tarp patirčių ir paversti skausmą išmintimi.

Tačiau šešėlinėje pusėje 9 gali tapti savęs aukojimu, nusivylimu žmonėmis, emociniu perdegimu arba gyvenimu praeities prisiminimuose. Tada žmogus per daug neša kitų naštą ir pamiršta savo kelią.

Brandi 9 energija reiškia kilnią stiprybę ir ramų užbaigtumą: kai žmogus moka duoti iš pilnatvės, o ne iš tuštumos. Jo didybė slypi gebėjime mylėti plačiau, bet likti ištikimam sau.`,
    keys: [
      'branda',
      'užbaigimas',
      'išmintis',
      'atjauta',
      'paleidimas',
      'tarnystė',
      'humanizmas',
      'sielos augimas',
    ],
  },
};

/**
 * Future expansion placeholder:
 * 
 * SS_CATEGORIES = {
 *   career:       { start: { 1: "...", ... }, end: { 1: "...", ... } },
 *   finance:      { start: { 1: "...", ... }, end: { 1: "...", ... } },
 *   relationships:{ start: { 1: "...", ... }, end: { 1: "...", ... } },
 *   health:       { start: { 1: "...", ... }, end: { 1: "...", ... } },
 *   ...
 * }
 */
